export default __webpack_public_path__ + "static/media/m-gif-1.eadd0f24.gif";